import React, { FC, HTMLAttributes, memo, useMemo } from "react";
import styled from "styled-components";

const RateMeter: FC<HTMLAttributes<HTMLDivElement> & { rate?: number | null }> = ({ rate, ...props }) => {
  const [isSuccess, percent] = useMemo(() => {
    if (rate) {
      const isSuccess = rate >= 100;
      const percent = isSuccess ? 100 : rate;
      return [isSuccess, percent];
    } else {
      return [false, 0];
    }
  }, [rate]);
  return (
    <Root {...props}>
      <Fill $percent={percent} />
      {isSuccess && (
        <Success>
          <SuccessDressRight />
          <Text>SUCCESS!!</Text>
          <SuccessDressLeft />
        </Success>
      )}
    </Root>
  );
};
export default memo(RateMeter);

const Root = styled.div`
  position: relative;
`;
const Fill = styled.div<{ $percent: number }>`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #dd0000;
  width: ${({ $percent }) => $percent}%;
  height: 100%;
`;
const Success = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before,
  &:after {
    content: "";
    display: block;
    width: 30%;
    height: 72%;
    position: absolute;
  }

  &:before {
    border-left: 1px solid #ff0000;
    border-bottom: 1px solid #ff0000;
    left: -3px;
    bottom: -3px;
  }

  &:after {
    border-right: 1px solid #ff0000;
    border-top: 1px solid #ff0000;
    top: -3px;
    right: -3px;
  }
`;
const SuccessDress = styled.div`
  width: 17.5%;
  height: calc(100% - 4px);
  position: absolute;
  top: 2px;
`;
const SuccessDressRight = styled(SuccessDress)`
  right: 2px;
  border-right: 3px solid #fff;
  border-bottom: 1px solid #fff;
`;
const SuccessDressLeft = styled(SuccessDress)`
  left: 2px;
  border-left: 3px solid #fff;
  border-top: 1px solid #fff;
`;
const Text = styled.p`
  font-size: 12px;
  color: #fff;
`;
